import React from 'react';
export function HomeLocalAuthoritySection() {
  return <section className="py-24 bg-black" data-id="element-1143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1144">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-1145">
          {/* Left Column - Content */}
          <div className="animate-scroll-fade-up" data-id="element-1146">
            <div className="inline-flex items-center gap-2 text-[#00D4FF] font-semibold text-sm mb-4" data-id="element-1147">
              <span className="w-2 h-2 rounded-full bg-[#00D4FF]" data-id="element-1148" />
              Serving Bloomington, Illinois Since 1999
            </div>

            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-1149">
              A Family-Focused Martial Arts School in{' '}
              <span className="text-[#00D4FF]" data-id="element-1150">Bloomington, Illinois</span>
            </h2>

            <div className="space-y-6 text-gray-300 text-lg leading-relaxed" data-id="element-1151">
              <p data-id="element-1152">
                Walker's Martial Arts provides high-quality martial arts
                training in Bloomington, Illinois, with a focus on family,
                affordability, and real-world self-defense. Our programs are
                designed for children, teens, and adults of all experience
                levels, creating an inclusive environment where students can
                build confidence, discipline, and lifelong skills.
              </p>

              <p data-id="element-1153">
                Our modern 4,200 square foot facility supports structured
                martial arts instruction, personal development, and practical
                self-defense training. Whether your goal is improving focus and
                fitness, learning self-defense skills, or helping your child
                develop confidence and respect, our experienced instructors
                emphasize safety, accountability, and positive growth.
              </p>

              <p data-id="element-1154">
                Since 1999, Walker's Martial Arts has proudly served families
                throughout McLean County. We believe martial arts training
                should be accessible, affordable, and impactful—helping
                individuals and families train together, grow together, and
                succeed together.
              </p>
            </div>
          </div>

          {/* Right Column - Community Image */}
          <div className="animate-scroll-scale-in relative h-full min-h-[400px] rounded-2xl overflow-hidden" style={{
          animationDelay: '0.2s'
        }} data-id="element-1155">
            <img src="https://cdn.magicpatterns.com/uploads/3hCLe7EGKtespePGSmJqvK/20251101_142024.jpg" alt="Walker's Martial Arts community event with students and mascot" className="w-full h-full object-cover" data-id="element-1156" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" data-id="element-1157" />
          </div>
        </div>
      </div>
    </section>;
}